<div style="display: flex; justify-content: center; width:100% !important;">
    <div class="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
</div>